import { render, staticRenderFns } from "./BrokerList.vue?vue&type=template&id=0b68d0cb"
import script from "./BrokerList.vue?vue&type=script&lang=js"
export * from "./BrokerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports